/**
 * Zoony PDP form: quantity steppers, AJAX add-to-cart → cart:update (opens drawer), sticky ATC.
 */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return;
      }
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    }
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  function collectSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function setQty(input, next) {
    var n = parseInt(next, 10);
    if (Number.isNaN(n) || n < 1) n = 1;
    input.value = String(n);
  }

  function dispatchCartUpdate(cart, sections, quantity, variantId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'zoony-product-form',
          data: {
            source: 'zoony-product-form',
            itemCount: quantity,
            variantId: variantId ? String(variantId) : undefined,
            sections: sections || {},
          },
        },
      })
    );
  }

  function ajaxAddToCart(form, quantity) {
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return Promise.reject(new Error('Missing variant'));

    var formData = new FormData(form);
    formData.set('quantity', String(quantity || 1));
    var sectionIds = collectSectionIds();
    if (sectionIds.length) formData.set('sections', sectionIds.join(','));

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Add to cart failed');
          err.payload = data;
          throw err;
        }
        return data;
      });
    }).then(function (addResponse) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          dispatchCartUpdate(cart, addResponse.sections, quantity, variantId);
          openCartDrawer();
          return cart;
        });
    });
  }

  function syncStickyPrice() {
    var stickyPrice = document.querySelector('[data-zoony-sticky-price]');
    var current = document.querySelector('[data-zoony-price-current]');
    if (stickyPrice && current) stickyPrice.textContent = current.textContent.trim();
  }

  function setupSticky(form) {
    var bar = document.querySelector('[data-zoony-sticky-atc]');
    var stickyAdd = document.querySelector('[data-zoony-sticky-add]');
    var ctas = form.querySelector('.zoony-product-ctas');
    if (!bar || !stickyAdd || !ctas || !('IntersectionObserver' in window)) return;

    syncStickyPrice();
    document.addEventListener('variant:change', syncStickyPrice);

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) bar.setAttribute('hidden', '');
        else bar.removeAttribute('hidden');
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(ctas);

    stickyAdd.addEventListener('click', function () {
      var qtyInput = form.querySelector('[data-zoony-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      stickyAdd.disabled = true;
      ajaxAddToCart(form, qty).finally(function () {
        stickyAdd.disabled = false;
      });
    });
  }

  onReady(function () {
    var form = document.getElementById('zoony-product-form');
    if (!form) return;

    var qtyInput = form.querySelector('[data-zoony-qty-input]');
    var dec = form.querySelector('[data-zoony-qty-dec]');
    var inc = form.querySelector('[data-zoony-qty-inc]');
    if (qtyInput && dec && inc) {
      dec.addEventListener('click', function () {
        setQty(qtyInput, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      inc.addEventListener('click', function () {
        setQty(qtyInput, (parseInt(qtyInput.value, 10) || 1) + 1);
      });
      qtyInput.addEventListener('change', function () {
        setQty(qtyInput, qtyInput.value);
      });
    }

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && (submitter.getAttribute('name') === 'return_to' || submitter.hasAttribute('data-zoony-buy-now'))) {
        return;
      }
      e.preventDefault();
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var atc = form.querySelector('[data-zoony-add-to-cart]');
      if (atc) atc.disabled = true;
      ajaxAddToCart(form, qty)
        .catch(function (err) {
          console.error(err);
          window.alert(err.message || 'Could not add to cart');
        })
        .finally(function () {
          if (atc) atc.disabled = false;
        });
    });

    setupSticky(form);
  });
})();
